import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { CommonModule } from '@angular/common';
import { Authenticator } from './authenticator';
import { TokenInterceptor } from './token-interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { StompConfig, StompService } from '@stomp/ng2-stompjs';
import { stompConfig } from './websocket-config';
import { HttpRequestBuilder } from './http-request-builder';

@NgModule({
  imports: [
    CommonModule,
    HttpModule
  ],
  declarations: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    StompService,
    Authenticator,
    TokenInterceptor,
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: StompConfig, useValue: stompConfig },
    HttpRequestBuilder
  ]
})
export class CoreModule { }



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/core/core.module.ts